import { render, staticRenderFns } from "./satation.vue?vue&type=template&id=112c022f"
import script from "./satation.vue?vue&type=script&lang=js"
export * from "./satation.vue?vue&type=script&lang=js"
import style0 from "./satation.vue?vue&type=style&index=0&id=112c022f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports